import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'Title for the freight account activation/connect chooser modal',
    defaultMessage: 'One More Step',
    id: 's8are1',
  },
  activateHeading: {
    description: 'Heading for the activate-a-new-account section of the freight account chooser modal',
    defaultMessage: 'One step to smarter freight shipping.',
    id: 'TYoU+V',
  },
  activateDescription: {
    description: 'Description for the activate-a-new-account section of the freight account chooser modal',
    defaultMessage: 'Activate your account to compare rates and book freight with Worldwide Express, without leaving ShipStation.',
    id: 'kGQTOJ',
  },
  activateButton: {
    description: 'Button label to activate a new ShipStation freight account',
    defaultMessage: 'Activate Freight Shipping',
    id: 'STghEi',
  },
  orDivider: {
    description: 'Divider text between the activate and connect sections of the freight account chooser modal',
    defaultMessage: 'Or',
    id: '76CyA+',
  },
  connectHeading: {
    description: 'Heading for the connect-an-existing-account section of the freight account chooser modal',
    defaultMessage: 'Already have an account? Connect it now.',
    id: 'E49709',
  },
  connectButton: {
    description: 'Button label to connect an existing freight provider account',
    defaultMessage: 'Connect',
    id: 'vl7GVZ',
  },
  connectOnlyModalTitle: {
    description: 'Title for the freight account chooser modal when only the connect-existing option is offered',
    defaultMessage: 'Connect Your Freight Account',
    id: '67HDHV',
  },
  connectOnlyHeading: {
    description: 'Heading for the connect-existing section when it is the only option in the modal',
    defaultMessage: 'Select the freight provider you want to connect.',
    id: 'N9jcTD',
  },
});
